import { render, staticRenderFns } from "./editAccount.vue?vue&type=template&id=160fc02c&scoped=true"
import script from "./editAccount.vue?vue&type=script&lang=js"
export * from "./editAccount.vue?vue&type=script&lang=js"
import style0 from "./editAccount.vue?vue&type=style&index=0&id=160fc02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160fc02c",
  null
  
)

export default component.exports